// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"wr_a bii_b bii_we"};